import {
  hooks,
  AddonBeam,
  AddonFooter,
  Buttons,
  ColorButton,
  Flex,
  Status404,
  Text,
} from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import dataAtIds from '../../dataAtIds.json';

const { useMediaQuery } = hooks;

const Error401: FunctionComponent = () => {
  const match = useMediaQuery(['864px']);

  return (
    <Flex
      backgroundColor="grape-5"
      data-trace-at-id={dataAtIds.ErrorPage401}
      direction="vertical"
      gap="x10"
      grow
      textColor="aqua-1"
    >
      <Flex>
        <AddonBeam
          addonIcon="Trace"
          addonName="Trace"
          backgroundColor="grape-4"
          isBeta
          textColor="gray-1"
        />
      </Flex>

      <Flex grow>
        <Status404 />

        <Flex paddingHorizontal="x6">
          <Text align="middle" config="5" margin="x8">
            Sorry, we were not able find your account. Please login via the add-on page for your app
            in Bitrise
          </Text>

          <Buttons
            alignChildren={match('864px') ? 'middle' : undefined}
            fullWidth={!match('864px')}
            gap={match('864px') ? 'x6' : 'x3'}
          >
            <ColorButton
              Component="a"
              color="white"
              href="https://app.bitrise.io/dashboard/apps"
              size="large"
            >
              Login to Bitrise
            </ColorButton>
          </Buttons>
        </Flex>
      </Flex>

      <Flex paddingVertical="x10">
        <AddonFooter addonName="Trace" />
      </Flex>
    </Flex>
  );
};

export default Error401;
